<section class="grid border-b border-t border-gray-100 bg-gray-50 px-4 py-24 sm:grid-cols-1 sm:px-5 md:px-0 lg:grid-cols-12">
  <div class="xs:col-span-12 sm:col-span-12 md:col-start-2 md:col-span-10 lg:col-start-4 lg:col-span-6">
    <p class="text-center text-2xl font-semibold leading-10 text-gray-900 font-['Inter']">
      {{ missionText }}
    </p>
  </div>
</section>
